export const routes = [
  {
    path: '/sala-principal',
    component: () => import(/* webpackChunkName: "ur" */ './components/SalaPrincipal'),
    name: 'sala.principal',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/sala-municipio-principal',
    component: () => import(/* webpackChunkName: "ur" */ './components/SalaMunicipioPrincipal'),
    name: 'sala.municipio.principal',
    meta: {
      requiresAuth: true
    }
  }
]
